import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "./useAppContext";
import { useEditor } from "./useEditor";
import { useMessageToState } from "./useMessageToState";

const getRowId = (editor: eXpress.core.IEditor) => editor.commandManager.getRowId();

function useDefinitionRowId() {
	return useMessageToState({
		name: "useDefinitionRowId",
		getState: getRowId,
	});
}

export function useProductErrorsAndWarnings() {
	const editor = useEditor();
	const { getFontSizeCorrectorAsync } = useAppContext();
	const rowId = useDefinitionRowId();

	const result = useQuery({
		queryKey: ["product-errors", rowId, getFontSizeCorrectorAsync],
		queryFn: async () => {
			return (
				await editor.validateAsync({
					getFontSizeCorrectorAsync,
					getLocalizedMonthNames: undefined,
				})
			).filter(
				(m) =>
					m.name === "BadQualityPhotoZones" ||
					m.name === "RejectedPhotosNotAllowed" ||
					m.name === "BadQualityTextZones" ||
					// We only want to show this when it's an error (embroidery), otherwise ignore.
					(m.name === "TextOutsideBounds" && m.isError),
			);
		},
		retry: false,
	});

	return {
		productErrorsAndWarnings: result.data ?? [],
		productErrorsAndWarningsLoading: result.isFetching,
		hasProductErrorsOrWarnings: !!result?.data?.length,
	};
}
